import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../auth.service';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { environment } from '../../../../environments/environment'
import { SharedAuthService } from '../../../shared/shared.auth.service';

@Injectable()
export class AuthGuard  {
    globalRoute: any;
    globalState: any;
    routeURL;
    constructor(
        private readonly router: Router,
        private readonly AuthService: AuthService,
        private readonly sharedAuthService: SharedAuthService
    ) {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.globalRoute = route;
        this.globalState = state;
        if (sessionStorage.getItem('token')) {
            // logged in so return true
            // console.log('token available');
            return true;
        }
        // not logged in so redirect to login page with the return url
        // this.router.navigate(['/login']);

        else if (environment.enableSSO) {
            this.sharedAuthService.clearMediaTokenCookie();
            Cookie.delete('access_token');
            Cookie.delete('expires_in');
            Cookie.delete('refresh_token');
            sessionStorage.clear();   
            sessionStorage.removeItem('MsId');
            sessionStorage.removeItem('lob');
            sessionStorage.removeItem('selectedSegment');
            sessionStorage.removeItem('isAdminRole');
            sessionStorage.removeItem('isWriteAccess');
            sessionStorage.removeItem('loggedInUserEmail');
            sessionStorage.removeItem('isModelEditor');
            sessionStorage.removeItem('userLastAction');
            sessionStorage.removeItem('selectedlob');
            sessionStorage.removeItem('landingPageContent');
            sessionStorage.removeItem('accessData');
            sessionStorage.removeItem('selectedsublob');
            sessionStorage.removeItem('flagAccess');
            sessionStorage.removeItem('config');
            sessionStorage.removeItem('currentUser');   
            return false;
        }
        else {
            this.router.navigate([{ outlets: { primary: 'login' } }]);
        }

    }
}
